export default __webpack_public_path__ + "TG-crk-SM-1000w.9fd504e.png";